import { APIBase } from './APIBase.service';
import { Injectable } from '@angular/core';
import {
  APIError, APIHTTPErrorResponse,
  ExistingUserRegistrationFormResponse,
  ExistingUserRegistrationFormSubmit,
  ProtectedTestAPIResponse,
} from '../../models/API.models';
import { firstValueFrom, map, Observable, of, throwError } from 'rxjs';
import { NGXLogger } from 'ngx-logger';
import { HttpClient } from '@angular/common/http';
import { TokenService } from '../auth/token.service';
import { catchError } from 'rxjs/operators';

export interface IAPIJoinFlowService {
  submitForm(
    params: ExistingUserRegistrationFormSubmit
  ): Promise<ExistingUserRegistrationFormResponse | APIHTTPErrorResponse>;
  testProtectedAPI(): Promise<ProtectedTestAPIResponse>;
}

@Injectable({
  providedIn: 'root',
})
export class APIJoinFlowService extends APIBase implements IAPIJoinFlowService {
  constructor(
    http: HttpClient,
    tokenService: TokenService,
    private logger: NGXLogger
  ) {
    super(http, tokenService);
  }

  async submitForm(
    params: Partial<ExistingUserRegistrationFormSubmit>
  ): Promise<ExistingUserRegistrationFormResponse | APIHTTPErrorResponse> {
    this.logger.debug('[APIJoinFlowService] submitForm');

    return firstValueFrom(this.post<ExistingUserRegistrationFormResponse>(
      '/users/register/existing',
      JSON.stringify(params),
      { headers: { ...(await this.authorizationHeader()) } }
    ).pipe(
      catchError((error: APIHTTPErrorResponse) => {
        return throwError(() => error);
      }),
    ));
  }

  /* istanbul ignore next */
  async testProtectedAPI(): Promise<ProtectedTestAPIResponse> {
    return firstValueFrom(
      this.get<ProtectedTestAPIResponse>('/test/chirp/auth/', {
        headers: { ...(await this.authorizationHeader()) },
      })
    );
  }
}
